import React from "react";
import { infoIconStyle, formGroupStyle } from "../styles/stepperStyles";

const infoIconPath = "../../../assets/images/info-button.png"
export const TextFieldWithCounter = ({
  value,
  onChange,
  placeholder,
  maxLength,
  className = "",
  rows,
  fieldError,
  id,
  tooltipImage,
  tooltipAlt,
}) => {
  const isTextarea = rows !== undefined;
  const Component = isTextarea ? "textarea" : "input";
  const type = isTextarea ? undefined : "text";

  return (
    <>
    <div className="d-flex align-items-center">
    <div style={formGroupStyle}>
      <div className="info-icon-container">
        <img src={infoIconPath} alt="Info" style={infoIconStyle} />
        {tooltipImage && (
          <div className="info-tooltip">
            <img src={tooltipImage} alt={tooltipAlt} />
          </div>
        )}
      </div>
      </div>
      <Component
        type={type}
        onChange={onChange}
        value={value || ""}
        className={`form-control rounded-4 ${fieldError ? "is-invalid" : ""} ${className}`}
        style={isTextarea ? {} : { height: "48px" }}
        placeholder={placeholder}
        id={id}
        maxLength={maxLength}
        rows={rows}
      />
            </div>

        <small className="text-muted text-end d-block">
          {(value?.length || 0)} / {maxLength}
        </small>
    </>
  );
};

